import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import data from './data';
import Firebase from 'src/Firebase.js'
import PaymentTableWrapper from './PaymentTableWrapper';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));


const PaymentListView = () => {
  const classes = useStyles();
  const [customers] = useState(data);

  useEffect(() => {
    // Update the document title using the browser API

    
  });


  return (
    <Page
      className={classes.root}
      title="Payments"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
         <div id='fk11'>
          <PaymentTableWrapper customers={customers}/>
          </div>
          

        </Box>
      </Container>
    </Page>
  );
};

export default PaymentListView;
